import BaseController from '../base';

export default class BasePlayerController extends BaseController {
  get elementsIdPrefix() {
    return 'ui';
  }
}
